// extracted by mini-css-extract-plugin
export default {"root":"IconSocialMediaLinkdin_root__NQ4Iq"};